<template>
  <div>
    <titulo-consulta-boletos />

    <filtro @resultado-filtro="filtrar" @limpar="limparResultado" />

    <tabela :items="items" @alterar-ordenacao="novaOrdenacao" />

    <paginacao
      v-model="paginacao"
      :total="paginacao.total"
      @input="getBoletos"
    />
  </div>
</template>
<script>
// Utils & Aux:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import breadcrumb from '@/common/utils/breadcrumb';

// Services:
import BoletoPixService from '@/common/services/boleto-pix/boleto-pix.service.js';

// Components:
import TituloConsultaBoletos from './components/TituloConsultaBoletos';
import Filtro from './components/filtro/Index';
import Tabela from './components/Tabela';
import Paginacao from '@/components/paginacao/Paginacao';

export default {
  components: {
    TituloConsultaBoletos,
    Filtro,
    Tabela,
    Paginacao,
  },
  data() {
    return {
      items: [],
      filtro: null,
      paginacao: {
        numeroDaPagina: 1,
        tamanhoDaPagina: 10,
        total: 0,
      },
      campoOrdenado: null,
      ordem: false,
    };
  },
  mounted() {
    breadcrumb.definir(this.$store, [
      { titulo: this.$t('FINANCEIRO.FINANCEIRO') },
      { titulo: this.$t('FINANCEIRO.CONSULTA_BOLETOS') },
    ]);
  },
  methods: {
    filtrar(filtro) {
      this.filtro = filtro;
      this.paginacao.numeroDaPagina = 1;
      this.getBoletos();
    },
    getBoletos() {
      if (!this.filtro) return;

      this.$store.dispatch(START_LOADING);
      BoletoPixService.obterBoletosPorFiltro(
        this.filtro,
        this.paginacao,
        this.campoOrdenado,
        this.ordem
      )
        .then(({ data }) => {
          this.items = data.itens;
          this.paginacao.total = data.paginacao.totalDeElementos;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    limparResultado() {
      this.filtro = null;
      this.items = [];
      this.paginacao.total = 0;
      this.paginacao.numeroDaPagina = 1;
    },
    novaOrdenacao(campoOrdenado, ordem) {
      this.campoOrdenado = campoOrdenado;
      this.ordem = !ordem;
      this.getBoletos();
    },
  },
};
</script>
